import styled from "styled-components";

export const WarrantyPageStyle=styled.div`


.table-main{
    padding:20px;
    display: flex;
    flex-direction: column;
}

.search-bar {
  display: flex;
  align-self:center;
  align-items: center;
  border: 1px solid #f28809;
  border-radius: 20px;
  width: 30%;
  background-color:white;
  padding:0 15px 0 5px;
  margin-bottom:10px;
  margin-top:15px;
  height:50px;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 5px;
  border-radius: 20px;
}


.search-icon{
  color:#f28809;
  font-size:20px;
  cursor:pointer;
}


.filter-div{
  display:flex;
  align-items: baseline;
  align-self:center;
  flex-direction: row;
  justify-content: center;
}

.btn-active-div{
  background-color:#f28809;
  font-family: "Inter var", sans-serif;
}


.table-container3{
  width:80%;
  display: flex;
  align-self: center;
  flex-direction: column;
}

.table-div2 {
  padding: 20px;
  display:flex;
  height:430px;
  overflow-y:auto;
  margin-bottom:20px;
  flex-wrap:wrap;
  justify-content:center;
}

.table-loading{
  text-align:center;
  font-size:1rem;
}

.heading-icon{
  color:#f28809;
}

.space-warranty{
  margin-bottom:50px;
}
`